import type { ScheduledRun, NewScheduledRunPayload } from '@/types/schedules'
import type { UtcScheduleTime } from '@/utils/scheduleTime'

// Shared scheduled-run payload builder, used by both the Advanced ScheduledRunCard and the
// simple-mode Automations lens (scheduledRunPayloadFromAutomation). It owns the payload-shape
// rules the backend expects — daysOfWeek only for weekly, dayOfMonth only for monthly, the
// enabled/disabled status mapping — so the two surfaces cannot drift apart. Times must already
// be UTC (convert with local12HourTimesToUtc / local12HourToUtcTime before calling).
export interface ScheduledRunFields {
  agentName: string
  label: string
  prompt: string
  /** ms epoch — the reference date the UTC times were converted against. */
  startDate: number
  timesToRun: UtcScheduleTime[]
  repeatInterval: ScheduledRun['repeatInterval']
  daysOfWeek: number[]
  dayOfMonth: number
  enabled: boolean
  sendEmail: boolean
}

// NewScheduledRunPayload is assignable to UpdateScheduledRunPayload (a Partial of the same
// fields), so this serves both create and update.
export function buildScheduledRunPayload(f: ScheduledRunFields): NewScheduledRunPayload {
  return {
    agentName: f.agentName,
    label: f.label,
    prompt: f.prompt,
    startDate: f.startDate,
    timesToRun: f.timesToRun,
    repeatInterval: f.repeatInterval,
    daysOfWeek: f.repeatInterval === 'weekly' ? f.daysOfWeek : undefined,
    dayOfMonth: f.repeatInterval === 'monthly' ? f.dayOfMonth : undefined,
    status: f.enabled ? 'enabled' : 'disabled',
    sendEmail: f.sendEmail
  }
}
